// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"00e9ce34","503":"2824512a"}[chunkId] + ".chunk.js";
};